import * as React from 'react';
import { Divider } from 'components/common/Divider';
import FilterActionButtons from 'components/common/searchfilter/FilterActionButtons';
import styled from 'styled-components';

interface Props {
  resetFilter: () => void;
  getSearchResult: () => void;
  children: React.ReactNode;
  disabled?: boolean;
}
const MemberSeachFilterLayout = ({ resetFilter, getSearchResult, children, disabled }: Props) => {
  return (
    <>
      <FilterContentWrapper>{children}</FilterContentWrapper>
      <ActionButtonsWrapper>
        <FilterActionButtons
          disabled={disabled}
          resetFilter={resetFilter}
          getSearchResult={getSearchResult}
        />
      </ActionButtonsWrapper>
      <Divider my={3} />
    </>
  );
};

const FilterContentWrapper = styled.div`
  width: 100%;
  padding: 0 ${props => props.theme.spacing(3)}px;
`;

const ActionButtonsWrapper = styled.div`
  .filter-action-buttons {
    justify-content: flex-end;
  }
`;

export default MemberSeachFilterLayout;
